export const ADD_TO_GLOBAL_FILTER = 'ADD_TO_GLOBAL_FILTER';
export const ADD_TO_GLOBAL_FILTER_ORG_IDS = 'ADD_TO_GLOBAL_FILTER_ORG_IDS';
export const REMOVE_FROM_GLOBAL_FILTER = 'REMOVE_FROM_GLOBAL_FILTER';
export const CLEAR_GLOBAL_FILTER = 'CLEAR_GLOBAL_FILTER';

export const REQUEST_ROLES_PERMISSIONS = 'REQUEST_ROLES_PERMISSIONS';
export const RECEIVE_ROLES_PERMISSIONS_SUCCESS = 'RECEIVE_ROLES_PERMISSIONS_SUCCESS';
export const RECEIVE_ROLES_PERMISSIONS_FAILURE = 'RECEIVE_ROLES_PERMISSIONS_FAILURE';

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_TOKEN_EXPIRY_TIME = 'UPDATE_TOKEN_EXPIRY_TIME';
export const NEW_LOGIN = 'NEW_LOGIN';

export const ACCEPTED_TERMS = 'ACCEPTED_TERMS';

export const REQUEST_USERS = 'REQUEST_USERS';
export const RECEIVE_USERS_SUCCESS = 'RECEIVE_USERS_SUCCESS';
export const RECEIVE_USERS_FAILURE = 'RECEIVE_USERS_FAILURE';

export const REQUEST_GET_USERS_ONBOARD = 'REQUEST_GET_USERS_ONBOARD';
export const RECEIVE_GET_USERS_ONBOARD_SUCCESS = 'RECEIVE_GET_USERS_ONBOARD_SUCCESS';
export const RECEIVE_GET_USERS_ONBOARD_FAILURE = 'RECEIVE_GET_USERS_ONBOARD_FAILURE';

export const REQUEST_USER_BY_ID = 'REQUEST_USER_BY_ID';
export const RECEIVE_USER_BY_ID_SUCCESS = 'RECEIVE_USER_BY_ID_SUCCESS';
export const RECEIVE_USER_BY_ID_FAILURE = 'RECEIVE_USER_BY_ID_FAILURE';

export const REQUEST_ALL_USERS_BY_MERCHANT_ID = 'REQUEST_ALL_USERS_BY_MERCHANT_ID';
export const RECEIVE_ALL_USERS_BY_MERCHANT_ID_SUCCESS = 'RECEIVE_ALL_USERS_BY_MERCHANT_ID_SUCCESS';
export const RECEIVE_ALL_USERS_BY_MERCHANT_ID_FAILURE = 'RECEIVE_ALL_USERS_BY_MERCHANT_ID_FAILURE';

export const REQUEST_SAVE_USER = 'REQUEST_SAVE_USER';
export const RECEIVE_SAVE_USER_SUCCESS = 'RECEIVE_SAVE_USER_SUCCESS';
export const RECEIVE_SAVE_USER_FAILURE = 'RECEIVE_SAVE_USER_FAILURE';

export const REQUEST_SAVE_USER_DATA_ACCESS = 'REQUEST_SAVE_USER_DATA_ACCESS';
export const RECEIVE_SAVE_USER_DATA_ACCESS_SUCCESS = 'RECEIVE_SAVE_USER_DATA_ACCESS_SUCCESS';
export const RECEIVE_SAVE_USER_DATA_ACCESS_FAILURE = 'RECEIVE_SAVE_USER_DATA_ACCESS_FAILURE';

export const REQUEST_USER_DATA_ACCESS = 'REQUEST_USER_DATA_ACCESS';
export const RECEIVE_USER_DATA_ACCESS_SUCCESS = 'RECEIVE_USER_DATA_ACCESS_SUCCESS';
export const RECEIVE_USER_DATA_ACCESS_FAILURE = 'RECEIVE_USER_DATA_ACCESS_FAILURE';

export const REQUEST_UPDATE_LOCATION = 'REQUEST_UPDATE_LOCATION';
export const RECEIVE_UPDATE_LOCATION_SUCCESS = 'RECEIVE_UPDATE_LOCATION_SUCCESS';
export const RECEIVE_UPDATE_LOCATION_FAILURE = 'RECEIVE_UPDATE_LOCATION_FAILURE';

export const REQUEST_USER_MERCHANTS = 'REQUEST_USER_MERCHANTS';
export const RECEIVE_USER_MERCHANTS_SUCCESS = 'RECEIVE_USER_MERCHANTS_SUCCESS';
export const RECEIVE_USER_MERCHANTS_FAILURE = 'RECEIVE_USER_MERCHANTS_FAILURE';
export const CLEAR_LAST_REGISTERED_MERCHANT = 'CLEAR_LAST_REGISTERED_MERCHANT';

export const REQUEST_MERCHANTS = 'REQUEST_MERCHANTS';
export const RECEIVE_MERCHANTS_SUCCESS = 'RECEIVE_MERCHANTS_SUCCESS';
export const RECEIVE_MERCHANTS_FAILURE = 'RECEIVE_MERCHANTS_FAILURE';

export const POST_REGISTER_MERCHANT = 'POST_REGISTER_MERCHANT';
export const REGISTER_MERCHANT_SUCCESS = 'REGISTER_MERCHANT_SUCCESS';
export const REGISTER_MERCHANT_FAILURE = 'REGISTER_MERCHANT_FAILURE';

export const REQUEST_USER_SUBSCRIPTIONS = 'REQUEST_USER_SUBSCRIPTIONS';
export const RECEIVE_USER_SUBSCRIPTIONS_SUCCESS = 'RECEIVE_USER_SUBSCRIPTIONS_SUCCESS';
export const RECEIVE_USER_SUBSCRIPTIONS_FAILURE = 'RECEIVE_USER_SUBSCRIPTIONS_FAILURE';

export const REQUEST_USER_PREFERENCES = 'REQUEST_USER_PREFERENCES';
export const RECEIVE_USER_PREFERENCES_SUCCESS = 'RECEIVE_USER_PREFERENCES_SUCCESS';
export const RECEIVE_USER_PREFERENCES_FAILURE = 'RECEIVE_USER_PREFERENCES_FAILURE';

export const REQUEST_SAVE_USER_PREFERENCES = 'REQUEST_SAVE_USER_PREFERENCES';
export const RECEIVE_SAVE_USER_PREFERENCES_SUCCESS = 'RECEIVE_SAVE_USER_PREFERENCES_SUCCESS';
export const RECEIVE_SAVE_USER_PREFERENCES_FAILURE = 'RECEIVE_SAVE_USER_PREFERENCES_FAILURE';

export const REQUEST_SAVE_USER_SUBSCRIPTIONS = 'REQUEST_SAVE_USER_SUBSCRIPTIONS';
export const RECEIVE_SAVE_USER_SUBSCRIPTIONS_SUCCESS = 'RECEIVE_SAVE_USER_SUBSCRIPTIONS_SUCCESS';
export const RECEIVE_SAVE_USER_SUBSCRIPTIONS_FAILURE = 'RECEIVE_SAVE_USER_SUBSCRIPTIONS_FAILURE';

export const REQUEST_USER_ACCESS = 'REQUEST_USER_ACCESS';
export const RECEIVE_USER_ACCESS_SUCCESS = 'RECEIVE_USER_ACCESS_SUCCESS';
export const RECEIVE_USER_ACCESS_FAILURE = 'RECEIVE_USER_ACCESS_FAILURE';

export const REQUEST_REPORTS = 'REQUEST_REPORTS';
export const RECEIVE_REPORTS_SUCCESS = 'RECEIVE_REPORTS_SUCCESS';
export const RECEIVE_REPORTS_FAILURE = 'RECEIVE_REPORTS_FAILURE';

export const REQUEST_REPORT_METADATA = 'REQUEST_REPORT_METADATA';
export const RECEIVE_REPORT_METADATA_SUCCESS = 'RECEIVE_REPORT_METADATA_SUCCESS';
export const RECEIVE_REPORT_METADATA_FAILURE = 'RECEIVE_REPORT_METADATA_FAILURE';

export const REQUEST_REPORT_DATA = 'REQUEST_REPORT_DATA';
export const RECEIVE_REPORT_DATA_SUCCESS = 'RECEIVE_REPORT_DATA_SUCCESS';
export const RECEIVE_REPORT_DATA_FAILURE = 'RECEIVE_REPORT_DATA_FAILURE';

export const REQUEST_REPORT_VISUALIZATIONS = 'REQUEST_REPORT_VISUALIZATIONS';
export const RECEIVE_REPORT_VISUALIZATIONS_SUCCESS = 'RECEIVE_REPORT_VISUALIZATIONS_SUCCESS';
export const RECEIVE_REPORT_VISUALIZATIONS_FAILURE = 'RECEIVE_REPORT_VISUALIZATIONS_FAILURE';

export const SET_CURRENT_REPORT_FILTER = 'SET_CURRENT_REPORT_FILTER';
export const CLEAR_CURRENT_REPORT_FILTER = 'CLEAR_CURRENT_REPORT_FILTER';

export const REQUEST_REPORT_USER_FILTERS = 'REQUEST_REPORT_USER_FILTERS';
export const RECEIVE_REPORT_USER_FILTERS_SUCCESS = 'RECEIVE_REPORT_USER_FILTERS_SUCCESS';
export const RECEIVE_REPORT_USER_FILTERS_FAILURE = 'RECEIVE_REPORT_USER_FILTERS_FAILURE';

export const REQUEST_SAVE_REPORT_FILTER = 'REQUEST_SAVE_REPORT_FILTER';
export const RECEIVE_SAVE_REPORT_FILTER_SUCCESS = 'RECEIVE_SAVE_REPORT_FILTER_SUCCESS';
export const RECEIVE_SAVE_REPORT_FILTER_FAILURE = 'RECEIVE_SAVE_REPORT_FILTER_FAILURE';

export const REQUEST_MESSAGES = 'REQUEST_MESSAGES';
export const RECEIVE_MESSAGES_SUCCESS = 'RECEIVE_MESSAGES_SUCCESS';
export const RECEIVE_MESSAGES_FAILURE = 'RECEIVE_MESSAGES_FAILURE';

export const REQUEST_MESSAGE_COUNT = 'REQUEST_MESSAGE_COUNT';
export const RECEIVE_MESSAGE_COUNT_SUCCESS = 'RECEIVE_MESSAGE_COUNT_SUCCESS';
export const RECEIVE_MESSAGE_COUNT_FAILURE = 'RECEIVE_MESSAGE_COUNT_FAILURE';

export const REQUEST_MESSAGES_UPDATE_STATUS = 'REQUEST_MESSAGES_UPDATE_STATUS';
export const RECEIVE_MESSAGES_UPDATE_STATUS_SUCCESS = 'RECEIVE_MESSAGES_UPDATE_STATUS_SUCCESS';
export const RECEIVE_MESSAGES_UPDATE_STATUS_FAILURE = 'RECEIVE_MESSAGES_UPDATE_STATUS_FAILURE';

export const RECEIVE_MESSAGES_UPDATE_SUCCESS = 'RECEIVE_MESSAGES_UPDATE_SUCCESS';

export const REQUEST_DOCUMENTS = 'REQUEST_DOCUMENTS';
export const RECEIVE_DOCUMENTS_SUCCESS = 'RECEIVE_DOCUMENTS_SUCCESS';
export const RECEIVE_DOCUMENTS_FAILURE = 'RECEIVE_DOCUMENTS_FAILURE';
export const REQUEST_DOCUMENT_ACCESS = 'REQUEST_DOCUMENT_ACCESS';
export const RECEIVE_DOCUMENT_ACCESS_SUCCESS = 'RECEIVE_DOCUMENT_ACCESS_SUCCESS';
export const RECEIVE_DOCUMENT_ACCESS_FAILURE = 'RECEIVE_DOCUMENT_ACCESS_FAILURE';

export const REQUEST_REPORT_ROW_DETAILS = 'REQUEST_REPORT_ROW_DETAILS';
export const RECEIVE_REPORT_ROW_DETAILS_SUCCESS = 'RECEIVE_REPORT_ROW_DETAILS_SUCCESS';
export const RECEIVE_REPORT_ROW_DETAILS_FAILURE = 'RECEIVE_REPORT_ROW_DETAILS_FAILURE';

export const REQUEST_STATEMENTS = 'REQUEST_STATEMENTS';
export const RECEIVE_STATEMENTS_SUCCESS = 'RECEIVE_STATEMENTS_SUCCESS';
export const RECEIVE_STATEMENTS_FAILURE = 'RECEIVE_STATEMENTS_FAILURE';

export const REQUEST_NEW_AUTH_PREFERENCES = 'REQUEST_NEW_AUTH_PREFERENCES';
export const RECEIVE_NEW_AUTH_PREFERENCES_SUCCESS = 'RECEIVE_NEW_AUTH_PREFERENCES_SUCCESS';
export const RECEIVE_NEW_AUTH_PREFERENCES_FAILURE = 'RECEIVE_NEW_AUTH_PREFERENCES_FAILURE';

export const POST_REGISTER_NEW_MERCHANT = 'POST_REGISTER_NEW_MERCHANT';
export const REGISTER_NEW_MERCHANT_SUCCESS = 'REGISTER_NEW_MERCHANT_SUCCESS';
export const REGISTER_NEW_MERCHANT_FAILURE = 'REGISTER_NEW_MERCHANT_FAILURE';

export const GET_ACCOUNT_ADMINS = 'GET_ACCOUNT_ADMINS';
export const GET_ACCOUNT_ADMINS_SUCCESS = 'GET_ACCOUNT_ADMINS_SUCCESS';
export const GET_ACCOUNT_ADMINS_FAILURE = 'GET_ACCOUNT_ADMINS__FAILURE';

export const GET_RELEVANT_TOPICS = 'GET_RELEVANT_TOPICS';
export const GET_RELEVANT_TOPICS_SUCCESS = 'GET_RELEVANT_TOPICS_SUCCESS';
export const GET_RELEVANT_TOPICS_FAILURE = 'GET_RELEVANT_TOPICS_FAILURE';

// reports API v2 actions
export const REQUEST_SAVE_REPORT_V2 = 'REQUEST_SAVE_REPORT_V2';
export const RECEIVE_SAVE_REPORT_SUCCESS_V2 = 'RECEIVE_SAVE_REPORT_SUCCESS_V2';
export const RECEIVE_SAVE_REPORT_FAILURE_V2 = 'RECEIVE_SAVE_REPORT_FAILURE_V2';

export const CLEAR_REPORTS_V2 = 'CLEAR_REPORTS_V2';

export const REQUEST_REPORTS_V2 = 'REQUEST_REPORTS_V2';
export const RECEIVE_REPORTS_SUCCESS_V2 = 'RECEIVE_REPORTS_SUCCESS_V2';
export const RECEIVED_ALLOWED_REPORT_LIST = 'RECEIVED_ALLOWED_REPORT_LIST';
export const RECEIVE_REPORTS_FAILURE_V2 = 'RECEIVE_REPORTS_FAILURE_V2';

export const REQUEST_ONE_REPORT_V2 = 'REQUEST_ONE_REPORT_V2';
export const RECEIVE_ONE_REPORT_SUCCESS_V2 = 'RECEIVE_ONE_REPORT_SUCCESS_V2';
export const RECEIVE_ONE_REPORT_FAILURE_V2 = 'RECEIVE_ONE_REPORT_FAILURE_V2';

export const REQUEST_REPORT_DATA_V2 = 'REQUEST_REPORT_DATA_V2';
export const RECEIVE_REPORT_DATA_SUCCESS_V2 = 'RECEIVE_REPORT_DATA_SUCCESS_V2';
export const RECEIVE_REPORT_DATA_FAILURE_V2 = 'RECEIVE_REPORT_DATA_FAILURE_V2';

export const REQUEST_REPORT_SUMMARY_V2 = 'REQUEST_REPORT_SUMMARY_V2';
export const RECEIVE_REPORT_SUMMARY_SUCCESS_V2 = 'RECEIVE_REPORT_SUMMARY_SUCCESS_V2';
export const RECEIVE_REPORT_SUMMARY_FAILURE_V2 = 'RECEIVE_REPORT_SUMMARY_FAILURE_V2';

export const REQUEST_REPORT_VISUALIZATIONS_V2 = 'REQUEST_REPORT_VISUALIZATIONS_V2';
export const RECEIVE_REPORT_VISUALIZATIONS_SUCCESS_V2 = 'RECEIVE_REPORT_VISUALIZATIONS_SUCCESS_V2';
export const RECEIVE_REPORT_VISUALIZATIONS_FAILURE_V2 = 'RECEIVE_REPORT_VISUALIZATIONS_FAILURE_V2';
export const CLEAR_REPORT_VISUALIZATIONS_V2 = 'CLEAR_REPORT_VISUALIZATIONS_V2';

export const REQUEST_REPORT_USER_FILTERS_V2 = 'REQUEST_REPORT_USER_FILTERS_V2';
export const RECEIVE_REPORT_USER_FILTERS_SUCCESS_V2 = 'RECEIVE_REPORT_USER_FILTERS_SUCCESS_V2';
export const RECEIVE_REPORT_USER_FILTERS_FAILURE_V2 = 'RECEIVE_REPORT_USER_FILTERS_FAILURE_V2';

export const REQUEST_DELETE_REPORT_USER_FILTERS_V2 = 'REQUEST_DELETE_REPORT_USER_FILTERS_V2';
export const RECEIVE_DELETE_REPORT_USER_FILTERS_SUCCESS_V2 = 'RECEIVE_DELETE_REPORT_USER_FILTERS_SUCCESS_V2';
export const RECEIVE_DELETE_REPORT_USER_FILTERS_FAILURE_V2 = 'RECEIVE_DELETE_REPORT_USER_FILTERS_FAILURE_V2';

export const REQUEST_SAVE_REPORT_FILTER_V2 = 'REQUEST_SAVE_REPORT_FILTER_V2';
export const RECEIVE_SAVE_REPORT_FILTER_SUCCESS_V2 = 'RECEIVE_SAVE_REPORT_FILTER_SUCCESS_V2';
export const RECEIVE_SAVE_REPORT_FILTER_FAILURE_V2 = 'RECEIVE_SAVE_REPORT_FILTER_FAILURE_V2';

export const REQUEST_TEMPLATES = 'REQUEST_TEMPLATES';
export const RECEIVE_TEMPLATES_SUCCESS = 'RECEIVE_TEMPLATES_SUCCESS';
export const RECEIVE_TEMPLATES_FAILURE = 'RECEIVE_TEMPLATES_FAILURE';
export const REQUEST_ONE_TEMPLATE = 'REQUEST_ONE_TEMPLATE';
export const RECEIVE_ONE_TEMPLATE_SUCCESS = 'RECEIVE_ONE_TEMPLATE_SUCCESS';
export const RECEIVE_ONE_TEMPLATE_FAILURE = 'RECEIVE_ONE_TEMPLATE_FAILURE';

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';

export const REQUEST_HIERARCHY_SELECTOR_FILTERS = 'REQUEST_HIERARCHY_SELECTOR_FILTERS';
export const REQUEST_HIERARCHY_SELECTOR_FILTERS_SUCCESS = 'REQUEST_HIERARCHY_SELECTOR_FILTERS_SUCCESS';
export const REQUEST_HIERARCHY_SELECTOR_FILTERS_FAILURE = 'REQUEST_HIERARCHY_SELECTOR_FILTERS_FAILURE';

export const REQUEST_HIERARCHY_SELECTOR_RECENT_SEARCHES = 'REQUEST_HIERARCHY_SELECTOR_RECENT_SEARCHES';
export const REQUEST_UPDATE_HIERARCHY_SELECTOR_RECENT_SEARCHES = 'REQUEST_UPDATE_HIERARCHY_SELECTOR_RECENT_SEARCHES';

export const REQUEST_SAVE_HIERARCHY_SELECTOR_FILTERS = 'REQUEST_SAVE_HIERARCHY_SELECTOR_FILTERS';
export const REQUEST_SAVE_HIERARCHY_SELECTOR_FILTERS_SUCCESS = 'REQUEST_SAVE_HIERARCHY_SELECTOR_FILTERS_SUCCESS';
export const REQUEST_SAVE_HIERARCHY_SELECTOR_FILTERS_FAILURE = 'REQUEST_SAVE_HIERARCHY_SELECTOR_FILTERS_FAILURE';

export const REQUEST_DELETE_HIERARCHY_SELECTOR_FILTERS = 'REQUEST_DELETE_HIERARCHY_SELECTOR_FILTERS';
export const REQUEST_DELETE_HIERARCHY_SELECTOR_FILTERS_SUCCESS = 'REQUEST_DELETE_HIERARCHY_SELECTOR_FILTERS_SUCCESS';
export const REQUEST_DELETE_HIERARCHY_SELECTOR_FILTERS_FAILURE = 'REQUEST_DELETE_HIERARCHY_SELECTOR_FILTERS_FAILURE';

export const REQUEST_SAVE_SCHEDULE = 'REQUEST_SAVE_SCHEDULE';
export const RECEIVE_SAVE_SCHEDULE_SUCCESS = 'RECEIVE_SAVE_SCHEDULE_SUCCESS';
export const RECEIVE_SAVE_SCHEDULE_FAILURE = 'RECEIVE_SAVE_SCHEDULE_FAILURE';

export const REQUEST_SCHEDULES = 'REQUEST_SCHEDULES';
export const RECEIVE_SCHEDULES_SUCCESS = 'RECEIVE_SCHEDULES_SUCCESS';
export const RECEIVE_SCHEDULES_FAILURE = 'RECEIVE_SCHEDULES_FAILURE';

export const REQUEST_ONE_SCHEDULE = 'REQUEST_ONE_SCHEDULE';
export const RECEIVE_ONE_SCHEDULE_SUCCESS = 'RECEIVE_ONE_SCHEDULE_SUCCESS';
export const RECEIVE_ONE_SCHEDULE_FAILURE = 'RECEIVE_ONE_SCHEDULE_FAILURE';

export const REQUEST_SHAREABLE_USERS = 'REQUEST_SHAREABLE_USERS';
export const RECEIVE_SHAREABLE_USERS_SUCCESS = 'RECEIVE_SHAREABLE_USERS_SUCCESS';
export const RECEIVE_SHAREABLE_USERS_FAILURE = 'RECEIVE_SHAREABLE_USERS_FAILURE';

export const REQUEST_SHARED_USERS_FOR_REPORT = 'REQUEST_SHARED_USERS_FOR_REPORT';
export const RECEIVE_SHARED_USERS_FOR_REPORT_SUCCESS = 'RECEIVE_SHARED_USERS_FOR_REPORT_SUCCESS';
export const RECEIVE_SHARED_USERS_FOR_REPORT_FAILURE = 'RECEIVE_SHARED_USERS_FOR_REPORT_FAILURE';

export const REQUEST_UPDATE_SHARED_USERS_FOR_REPORT = 'REQUEST_UPDATE_SHARED_USERS_FOR_REPORT';
export const RECEIVE_UPDATE_SHARED_USERS_FOR_REPORT_SUCCESS = 'RECEIVE_UPDATE_SHARED_USERS_FOR_REPORT_SUCCESS';
export const RECEIVE_UPDATE_SHARED_USERS_FOR_REPORT_FAILURE = 'RECEIVE_UPDATE_SHARED_USERS_FOR_REPORT_FAILURE';

export const REQUEST_ALLOW_REPORT_SUPPORT = 'REQUEST_ALLOW_REPORT_SUPPORT';
export const RECEIVE_ALLOW_REPORT_SUPPORT_SUCCESS = 'RECEIVE_ALLOW_REPORT_SUPPORT_SUCCESS';
export const RECEIVE_ALLOW_REPORT_SUPPORT_FAILURE = 'RECEIVE_ALLOW_REPORT_SUPPORT_FAILURE';

export const REQUEST_START_REPORT_SUPPORT_SESSION = 'REQUEST_START_REPORT_SUPPORT_SESSION';
export const RECEIVE_START_REPORT_SUPPORT_SESSION_SUCCESS = 'RECEIVE_START_REPORT_SUPPORT_SESSION_SUCCESS';
export const RECEIVE_START_REPORT_SUPPORT_SESSION_FAILURE = 'RECEIVE_START_REPORT_SUPPORT_SESSION_FAILURE';

export const REQUEST_END_REPORT_SUPPORT_SESSION_USER = 'REQUEST_END_REPORT_SUPPORT_SESSION_USER';
export const RECEIVE_END_REPORT_SUPPORT_SESSION_USER_SUCCESS = 'RECEIVE_END_REPORT_SUPPORT_SESSION_USER_SUCCESS';
export const RECEIVE_END_REPORT_SUPPORT_SESSION_USER_FAILURE = 'RECEIVE_END_REPORT_SUPPORT_SESSION_USER_FAILURE';

export const REQUEST_END_REPORT_SUPPORT_SESSION_TECH = 'REQUEST_END_REPORT_SUPPORT_SESSION_TECH';
export const RECEIVE_END_REPORT_SUPPORT_SESSION_TECH_SUCCESS = 'RECEIVE_END_REPORT_SUPPORT_SESSION_TECH_SUCCESS';
export const RECEIVE_END_REPORT_SUPPORT_SESSION_TECH_FAILURE = 'RECEIVE_END_REPORT_SUPPORT_SESSION_TECH_FAILURE';

export const REQUEST_GET_REPORT_SUPPORT_REQUESTED_SESSION = 'REQUEST_GET_REPORT_SUPPORT_REQUESTED_SESSION';
export const RECEIVE_GET_REPORT_SUPPORT_REQUESTED_SESSION_SUCCESS =
  'RECEIVE_GET_REPORT_SUPPORT_REQUESTED_SESSION_SUCCESS';
export const RECEIVE_GET_REPORT_SUPPORT_REQUESTED_SESSION_FAILURE =
  'RECEIVE_GET_REPORT_SUPPORT_REQUESTED_SESSION_FAILURE';

export const REQUEST_GET_REPORT_SUPPORT_PROVIDED_SESSION = 'REQUEST_GET_REPORT_SUPPORT_PROVIDED_SESSION';
export const RECEIVE_GET_REPORT_SUPPORT_PROVIDED_SESSION_SUCCESS =
  'RECEIVE_GET_REPORT_SUPPORT_PROVIDED_SESSION_SUCCESS';
export const RECEIVE_GET_REPORT_SUPPORT_PROVIDED_SESSION_FAILURE =
  'RECEIVE_GET_REPORT_SUPPORT_PROVIDED_SESSION_FAILURE';

export const SAVE_CURRENCY_FROM_DASHBOARD = 'SAVE_CURRENCY_FROM_DASHBOARD';

export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const REQUEST_MERCHANT_PRODUCTS = 'REQUEST_MERCHANT_PRODUCTS';
export const REQUEST_PRODUCT_SELECTION = 'REQUEST_PRODUCT_SELECTION';
export const UPDATE_PRODUCT_DATA = 'UPDATE_PRODUCT_DATA';
export const REQUEST_DOWNLOAD_ACTION_STATUS = 'REQUEST_DOWNLOAD_ACTION_STATUS';
export const SUCCESS_DOWNLOAD_ACTION_STATUS = 'SUCCESS_DOWNLOAD_ACTION_STATUS';
export const FAILURE_DOWNLOAD_ACTION_STATUS = 'FAILURE_DOWNLOAD_ACTION_STATUS';
export const SAVE_ACTUAL_DOWNLOAD_ACTION_REQUEST = 'SAVE_ACTUAL_DOWNLOAD_ACTION_REQUEST';
export const CLEAR_ACTUAL_DOWNLOAD_ACTION_REQUEST = 'CLEAR_ACTUAL_DOWNLOAD_ACTION_REQUEST';
export const REMOVE_PRODUCT_SELECTION = 'REMOVE_PRODUCT_SELECTION';
export const UPDATE_ANALYTICS_PRODUCTS = 'UPDATE_ANALYTICS_PRODUCTS';
export const SAVE_PRODUCT_SUCCESS = 'SAVE_PRODUCT_SUCCESS';
export const CANCEL_PRODUCT_SUCCESS = 'CANCEL_PRODUCT_SUCCESS';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';

export const RECEIVE_ALERT_PREFERENCES = 'RECEIVE_ALERT_PREFERENCES';
export const DELETE_ALERT_PREFERENCES = 'DELETE_ALERT_PREFERENCES';
export const DELETE_ALERT_PREFERENCES_KEY = 'DELETE_ALERT_PREFERENCES_KEY';
export const SAVE_REPORT_CURRENT_FILTERS = 'SAVE_REPORT_CURRENT_FILTERS';

export const REQUEST_GET_ONBOARD_USERS = 'REQUEST_GET_ONBOARD_USERS';
export const RECEIVE_GET_ONBOARD_USERS_SUCCESS = 'RECEIVE_GET_ONBOARD_USERS_SUCCESS';
export const RECEIVE_GET_ONBOARD_USERS_FAILURE = 'RECEIVE_GET_ONBOARD_USERS_FAILURE';

export const REQUEST_DATA_ACCESS = 'REQUEST_DATA_ACCESS';
export const RECEIVE_DATA_ACCESS_SUCCESS = 'RECEIVE_DATA_ACCESS_SUCCESS';
export const RECEIVE_DATA_ACCESS_FAILURE = 'RECEIVE_DATA_ACCESS_FAILURE';

export const REQUEST_USER_APPLICATIONS = 'REQUEST_USER_APPLICATIONS';
export const RECEIVE_USER_APPLICATIONS_SUCCESS = 'RECEIVE_USER_APPLICATIONS_SUCCESS';
export const RECEIVE_USER_APPLICATIONS_FAILURE = 'RECEIVE_USER_APPLICATIONS_FAILURE';

export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_DISMISS = 'NOTIFICATION_DISMISS';
export const NOTIFICATION_DANGER = 'NOTIFICATION_DANGER';
export const NOTIFICATION_WARNING = 'NOTIFICATION_WARNING';
export const NOTIFICATION_ACCOUNT_NUMBER = 'NOTIFICATION_ACCOUNT_NUMBER';
export const NOTIFICATION_MANUAL_TRANSACTION = 'NOTIFICATION_MANUAL_TRANSACTION';
export const NOTIFICATION_TAKE_ACTION_INTERNAL_CASE = 'NOTIFICATION_TAKE_ACTION_INTERNAL_CASE';

export const ADD_CASE = 'ADD_CASE';
export const REMOVE_CASE = 'REMOVE_CASE';
export const REMOVE_ALL_OPEN_CASES = 'REMOVE_ALL_OPEN_CASES';

export const ADD_CASE_NUMBER = 'ADD_CASE_NUMBER';

export const FETCH_SEARCH_ELEMENTS = 'FETCH_SEARCH_ELEMENTS';
export const FETCH_FILTER_ELEMENTS = 'FETCH_FILTER_ELEMENTS';
export const SET_FILTER_LIST_SUCCESS = 'SET_FILTER_LIST_SUCCESS';
export const GET_FILTER_LIST_FAILURE = 'GET_FILTER_LIST_FAILURE';
export const SET_SAVED_FILTER_LIST_SUCCESS = 'SET_SAVED_FILTER_LIST_SUCCESS';
export const GET_MULTI_SELECT_VALUE = 'GET_MULTI_SELECT_VALUE';
export const SAVE_ACTIVE_FILTER = 'SAVE_ACTIVE_FILTER';
export const DELETE_SAVED_FILTER = 'DELETE_SAVED_FILTER';
export const SET_SEARCH_TYPE_ID = 'SET_SEARCH_TYPE_ID';
export const FETCH_DATA_COLUMNS = 'FETCH_DATA_COLUMNS';

export const REQUEST_CASE_STAGE_IMAGES = 'REQUEST_CASE_STAGE_IMAGES';
export const RECEIVE_CASE_STAGE_IMAGES_SUCCESS = 'RECEIVE_CASE_STAGE_IMAGES_SUCCESS';
export const RECEIVE_CASE_STAGE_IMAGES_FAILURE = 'RECEIVE_CASE_STAGE_IMAGES_FAILURE';
export const RESET_CURRENT_STAGE_IMAGES = 'RESET_CURRENT_STAGE_IMAGES';

export const TRANSFORM_IMAGE = 'TRANSFORM_IMAGE';
export const REQUEST_GET_IMAGE_BY_ID = 'REQUEST_GET_IMAGE_BY_ID';
export const RECEIVE_GET_IMAGE_BY_ID_SUCCESS = 'RECEIVE_GET_IMAGE_BY_ID_SUCCESS';
export const RECEIVE_GET_IMAGE_BY_ID_FAILURE = 'RECEIVE_GET_IMAGE_BY_ID_FAILURE';

export const REQUEST_UNLINK_IMAGE = 'REQUEST_UNLINK_IMAGE';
export const RECEIVE_UNLINK_IMAGE_SUCCESS = 'RECEIVE_UNLINK_IMAGE_SUCCESS';
export const RECEIVE_UNLINK_IMAGE_FAILURE = 'RECEIVE_UNLINK_IMAGE_FAILURE';

export const SET_DRAWER_OPEN_FLAG = 'SET_DRAWER_OPEN_FLAG';
export const SET_SEARCH_OPEN_FLAG = 'SET_SEARCH_OPEN_FLAG';
export const SET_APP_SEARCH_DATA_COLUMNS = 'SET_APP_SEARCH_DATA_COLUMNS';
export const UPDATE_NESTED_FIELD_SELECTOR_DATA = 'UPDATE_NESTED_FIELD_SELECTOR_DATA';
export const RESET_NESTED_FIELD_SELECTOR_DATA = 'RESET_NESTED_FIELD_SELECTOR_DATA';

export const SET_ACCOUNTNUMBER_LOCK = 'SET_ACCOUNTNUMBER_LOCK';
export const SET_UNSET_LOCK = 'SET_UNSET_LOCK';

export const SET_CORDS = 'SET_CORDS';
export const RESET_CORDS = 'RESET_CORDS';

export const ADD_TIMELINE_FILTERS = 'ADD_TIMELINE_FILTERS';
export const UPDATE_GLOBAL_FILTER = 'SET_GLOBAL_FILTER';
export const ADD_SUPPORT_REQUEST_ORGID_TO_GLOBAL_ORG_IDS = 'ADD_SUPPORT_REQUEST_ORGID_TO_GLOBAL_ORG_IDS';
export const CLEAR_SUPPORT_REQUEST_GLOBAL_FILTER = 'CLEAR_SUPPORT_REQUEST_GLOBAL_FILTER';
export const REQUEST_USER_ORGANIZATIONS = 'REQUEST_USER_ORGANIZATIONS';
export const RECEIVE_USER_ORGANIZATIONS_SUCCESS = 'RECEIVE_USER_ORGANIZATIONS_SUCCESS';
export const RECEIVE_USER_ORGANIZATIONS_FAILURE = 'RECEIVE_USER_ORGANIZATIONS_FAILURE';
export const UPDATE_SCHEDULE_GLOBAL_FILTER = 'SET_SCHEDULE_GLOBAL_FILTER';

export const REQUEST_USERADMIN_ORGANIZATIONS = 'REQUEST_USERADMIN_ORGANIZATIONS';
export const RECEIVE_USERADMIN_ORGANIZATIONS_SUCCESS = 'RECEIVE_USERADMIN_ORGANIZATIONS_SUCCESS';
export const RECEIVE_USERADMIN_ORGANIZATIONS_FAILURE = 'RECEIVE_USERADMIN_ORGANIZATIONS_FAILURE';

export const REQUEST_BATCH_ORGANIZATIONS = 'REQUEST_BATCH_ORGANIZATIONS';
export const RECEIVE_BATCH_ORGANIZATIONS_SUCCESS = 'RECEIVE_BATCH_ORGANIZATIONS_SUCCESS';
export const RECEIVE_BATCH_ORGANIZATIONS_FAILURE = 'RECEIVE_BATCH_ORGANIZATIONS_FAILURE';

export const REQUEST_LOGINUSER_ORGANIZATIONS = 'REQUEST_LOGINUSER_ORGANIZATIONS';
export const RECEIVE_LOGINUSER_ORGANIZATIONS_SUCCESS = 'RECEIVE_LOGINUSER_ORGANIZATIONS_SUCCESS';
export const RECEIVE_LOGINUSER_ORGANIZATIONS_FAILURE = 'RECEIVE_LOGINUSER_ORGANIZATIONS_FAILURE';

export const REQUEST_ORGANIZATION_MERCHANT_COUNT = 'REQUEST_ORGANIZATION_MERCHANT_COUNT';
export const RECEIVE_ORGANIZATION_MERCHANT_COUNT_SUCCESS = 'RECEIVE_ORGANIZATION_MERCHANT_COUNT_SUCCESS';
export const RECEIVE_ORGANIZATION_MERCHANT_COUNT_FAILURE = 'RECEIVE_ORGANIZATION_MERCHANT_COUNT_FAILURE';
export const TOGGLE_APP_SEARCH_PANEL = 'TOGGLE_APP_SEARCH_PANEL';
export const SET_MERCHANT_DETAILS = 'SET_MERCHANT_DETAILS';
export const SET_RELATED_GRID_LOADED = 'SET_RELATED_GRID_LOADED';
export const INITIATE_IMAGE_ARCHIVAL = 'INITIATE_IMAGE_ARCHIVAL';
export const IMAGE_ARCHIVE_SUCCESS = 'IMAGE_ARCHIVE_SUCCESS';
export const IMAGE_ARCHIVE_FAILURE = 'IMAGE_ARCHIVE_FAILURE';
export const INITIATE_IMAGE_SELECTION = 'INITIATE_IMAGE_SELECTION';

export const SET_DATA_SEARCH_TRANSACTION_GRID_PROP = 'SET_DATA_SEARCH_TRANSACTION_GRID_PROP';
export const SET_AMEX_DISPUTE_REASON_CODE = 'SET_AMEX_DISPUTE_REASON_CODE';

export const SET_UNRESOLVED_BANNER_STATUS = 'SET_UNRESOLVED_BANNER_STATUS';
export const CASE_DATA = 'CASE_DATA';
export const AMEX_DISPUTE_STAGES = 'AMEX_DISPUTE_STAGES';
export const CASE_DATA_FAILURE = 'CASE_DATA_FAILURE';
export const UNLOAD_CASE_INFO = 'UNLOAD_CASE_INFO';
export const UNLOAD_CASE_ERROR = 'UNLOAD_CASE_ERROR';
export const UNLOAD_CASE_AS_ACTIVE = 'UNLOAD_CASE_AS_ACTIVE';
export const UNLOAD_ALL_CASES = 'UNLOAD_ALL_CASES';
export const RESET_CASE_UPDATE = 'RESET_CASE_UPDATE';
export const CASE_REVISIT = 'CASE_REVISIT';
export const RESET_CASE_REVISIT = 'RESET_CASE_REVISIT';

export const SET_ACTIVE_STAGE_INDICATOR_SETTINGS_OPEN_FLAG = 'SET_ACTIVE_STAGE_INDICATOR_SETTINGS_OPEN_FLAG';
export const CASE_DOCUMENTS = 'CASE_DOCUMENTS';
export const RESET_CASE_DOCUMENTS = 'RESET_CASE_DOCUMENTS';
export const SELECTED_CASE_DOCUMENTS = 'SELECTED_CASE_DOCUMENTS';
export const UPDATED_CASE_DOCUMENTS = 'UPDATED_CASE_DOCUMENTS';
export const RESET_SELECTED_DOCUMENTS = 'RESET_SELECTED_DOCUMENTS';

export const SET_ACCOUNTS_PROFILE = 'SET_ACCOUNTS_PROFILE';
